/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "eris",
        "0": "oe",
        "1": "cras",
        "future": {
          "one": "intro de {0} die",
          "other": "intro de {0} dies"
        },
        "past": {
          "one": "{0} die a como",
          "other": "{0} dies a como"
        }
      },
      "day-narrow": {
        "-1": "eris",
        "0": "oe",
        "1": "cras",
        "future": {
          "one": "intro de {0} die",
          "other": "intro de {0} dies"
        },
        "past": {
          "one": "{0} die a como",
          "other": "{0} dies a como"
        }
      },
      "day-short": {
        "-1": "eris",
        "0": "oe",
        "1": "cras",
        "future": {
          "one": "intro de {0} die",
          "other": "intro de {0} dies"
        },
        "past": {
          "one": "{0} die a como",
          "other": "{0} dies a como"
        }
      },
      "hour": {
        "0": "cust’ora",
        "future": {
          "one": "intro de {0} ora",
          "other": "intro de {0} oras"
        },
        "past": {
          "one": "{0} ora a como",
          "other": "{0} oras a como"
        }
      },
      "hour-narrow": {
        "0": "cust’ora",
        "future": {
          "one": "intro de {0} o",
          "other": "intro de {0} o"
        },
        "past": {
          "one": "{0} o a como",
          "other": "{0} o a como"
        }
      },
      "hour-short": {
        "0": "cust’ora",
        "future": {
          "one": "intro de {0} ora",
          "other": "intro de {0} oras"
        },
        "past": {
          "one": "{0} ora a como",
          "other": "{0} oras a como"
        }
      },
      "minute": {
        "0": "custu minutu",
        "future": {
          "one": "intro de {0} minutu",
          "other": "intro de {0} minutos"
        },
        "past": {
          "one": "{0} minutu a como",
          "other": "{0} minutos a como"
        }
      },
      "minute-narrow": {
        "0": "custu minutu",
        "future": {
          "one": "intro de {0} m",
          "other": "intro de {0} m"
        },
        "past": {
          "one": "{0} m a como",
          "other": "{0} m a como"
        }
      },
      "minute-short": {
        "0": "custu minutu",
        "future": {
          "one": "intro de {0} min.",
          "other": "intro de {0} min."
        },
        "past": {
          "one": "{0} min. a como",
          "other": "{0} min. a como"
        }
      },
      "month": {
        "-1": "su mese coladu",
        "0": "custu mese",
        "1": "su mese chi intrat",
        "future": {
          "one": "intro de {0} mese",
          "other": "intro de {0} meses"
        },
        "past": {
          "one": "{0} mese a como",
          "other": "{0} meses a como"
        }
      },
      "month-narrow": {
        "-1": "su mese coladu",
        "0": "custu mese",
        "1": "su mese chi intrat",
        "future": {
          "one": "intro de {0} mese",
          "other": "intro de {0} meses"
        },
        "past": {
          "one": "{0} mese a como",
          "other": "{0} meses a como"
        }
      },
      "month-short": {
        "-1": "su mese coladu",
        "0": "custu mese",
        "1": "su mese chi intrat",
        "future": {
          "one": "intro de {0} mese",
          "other": "intro de {0} meses"
        },
        "past": {
          "one": "{0} mese a como",
          "other": "{0} meses a como"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "su trimestre coladu",
        "0": "custu trimestre",
        "1": "su trimestre chi intrat",
        "future": {
          "one": "intro de {0} trimestre",
          "other": "intro de {0} trimestres"
        },
        "past": {
          "one": "{0} trimestre a como",
          "other": "{0} trimestres a como"
        }
      },
      "quarter-narrow": {
        "-1": "su trim. coladu",
        "0": "custu trim.",
        "1": "su trim. chi intrat",
        "future": {
          "one": "intro de {0} trim.",
          "other": "intro de {0} trim."
        },
        "past": {
          "one": "{0} trim. a como",
          "other": "{0} trim. a como"
        }
      },
      "quarter-short": {
        "-1": "su trim. coladu",
        "0": "custu trim.",
        "1": "su trim. chi intrat",
        "future": {
          "one": "intro de {0} trim.",
          "other": "intro de {0} trim."
        },
        "past": {
          "one": "{0} trim. a como",
          "other": "{0} trim. a como"
        }
      },
      "second": {
        "0": "como",
        "future": {
          "one": "intro de {0} segundu",
          "other": "intro de {0} segundos"
        },
        "past": {
          "one": "{0} segundu a como",
          "other": "{0} segundos a como"
        }
      },
      "second-narrow": {
        "0": "como",
        "future": {
          "one": "intro de {0} s",
          "other": "intro de {0} s"
        },
        "past": {
          "one": "{0} s a como",
          "other": "{0} s a como"
        }
      },
      "second-short": {
        "0": "como",
        "future": {
          "one": "intro de {0} seg.",
          "other": "intro de {0} seg."
        },
        "past": {
          "one": "{0} seg. a como",
          "other": "{0} seg. a como"
        }
      },
      "week": {
        "-1": "sa chida colada",
        "0": "custa chida",
        "1": "sa chida chi intrat",
        "future": {
          "one": "intro de {0} chida",
          "other": "intro de {0} chidas"
        },
        "past": {
          "one": "{0} chida a como",
          "other": "{0} chidas a como"
        }
      },
      "week-narrow": {
        "-1": "sa chida colada",
        "0": "custa chida",
        "1": "sa chida chi intrat",
        "future": {
          "one": "intro de {0} ch.",
          "other": "intro de {0} ch."
        },
        "past": {
          "one": "{0} ch. a como",
          "other": "{0} ch. a como"
        }
      },
      "week-short": {
        "-1": "sa chida colada",
        "0": "custa chida",
        "1": "sa chida chi intrat",
        "future": {
          "one": "intro de {0} ch.",
          "other": "intro de {0} ch."
        },
        "past": {
          "one": "{0} ch. a como",
          "other": "{0} ch. a como"
        }
      },
      "year": {
        "-1": "ocannu coladu",
        "0": "ocannu",
        "1": "ocannu chi benit",
        "future": {
          "one": "intro de {0} annu",
          "other": "intro de {0} annos"
        },
        "past": {
          "one": "{0} annu a como",
          "other": "{0} annos a como"
        }
      },
      "year-narrow": {
        "-1": "ocannu coladu",
        "0": "ocannu",
        "1": "ocannu chi benit",
        "future": {
          "one": "intro de {0} annu",
          "other": "intro de {0} annos"
        },
        "past": {
          "one": "{0} annu a como",
          "other": "{0} annos a como"
        }
      },
      "year-short": {
        "-1": "ocannu coladu",
        "0": "ocannu",
        "1": "ocannu chi benit",
        "future": {
          "one": "intro de {0} annu",
          "other": "intro de {0} annos"
        },
        "past": {
          "one": "{0} annu a como",
          "other": "{0} annos a como"
        }
      }
    },
    "locale": "sc"
  });
}